import React, { Component } from 'react';
import Header from './Layout/Header';
import VisitorTable from './VisitorCommon/VisitorTable';

import { connect } from 'react-redux';
import { CSVLink } from 'react-csv';
import VisitorAntDTable from './VisitorCommon/VisitorAntDTable';
import { VisitorData, CheckLoader } from '../Redux/action/visitorAction';
import { dataUser } from './Helpers/util';
import { getToken } from '../Component/Helpers/util';
import { Navigate } from 'react-router-dom';
import MarketingPanel from '../Component/MarketingPanel';
import { getServiceAccess } from '../Redux/action/userActions';
import Sidebar from '../Component/Layout/Sidebar';
import CustomHeader from '../Component/Layout/Header';
import VisitorExport from './VisitorCommon/VisitorExport';
import { Layout } from 'antd';
import SwInput from './Common/FormComponent/SwInput';
import SwToggleButtonGroup from './Common/SwToggleButtonGroup/SwToggleButtonGroup';
import SwOffCanvas from './Common/SwOffCanvas/SwOffCanvas';
import VisitorPopUp from './VisitorCommon/VisitorPopUp';
import SwButton from './Common/SwButtons/SwButtons';
import dayjs from 'dayjs';
import AntDDatePicker from './Common/AntDDateTimePicker/AntDDatePicker';



const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

class VisitorManagement extends Component {
  constructor(props) {
    super(props);
    const today = dayjs();
    this.state = {
      company_id: UserObj.company_id,
      company_name: UserObj.company_name,
      pgno: 1,
      filterData: {},
  showVisitorPopup: false,     // ✅ Add this
  selectedVisitor: null,  // data for popup
      SortData: '',
      status: 'all',
      row: 25,
      isSearchVisible: false,
      searchText: '',
      accessServiceLists: [],
      loaderServiceAccess: true,
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
      collapsed: true,

      showVisitorExportModal: false,

      startDate: today.startOf('month'),
      endDate: today,
      appliedStartDate: today.startOf('month'),
      appliedEndDate: today,

      showSlowLoadMessage: false,
    };
    this.forwordPage = this.forwordPage.bind(this);
    this.pageBackword = this.pageBackword.bind(this);
  }

  componentDidUpdate(prevProps) {
    const prevLoader = prevProps?.visitorReducer?.loader;
    const currLoader = this.props?.visitorReducer?.loader;
    if (currLoader && !prevLoader) {
      // Loading just started — set 10s watchdog
      if (this.slowLoadTimer) clearTimeout(this.slowLoadTimer);
      if (this.state.showSlowLoadMessage) this.setState({ showSlowLoadMessage: false });
      this.slowLoadTimer = setTimeout(() => {
        this.setState({ showSlowLoadMessage: true });
      }, 10000);
    }
    if (!currLoader && prevLoader) {
      // Loading finished — clear watchdog and hide message
      if (this.slowLoadTimer) clearTimeout(this.slowLoadTimer);
      if (this.state.showSlowLoadMessage) this.setState({ showSlowLoadMessage: false });
    }
  }

  componentWillUnmount() {
    if (this.slowLoadTimer) clearTimeout(this.slowLoadTimer);
  }

  disabledStartDate = current => {
    if (!current) return false;
    const threeMonthsAgoStart = dayjs().subtract(3, 'month').startOf('month');
    const today = dayjs().endOf('day');
    return current < threeMonthsAgoStart || current > today;
  };

  // End Date is intentionally unconstrained so future-invited visitors
  // (whose entries are dated in the future) remain visible in the listing.
  disabledEndDate = () => false;

  handleApply = () => {
    const { startDate, endDate } = this.state;
    if (!startDate || !endDate) return;
    this.setState({ appliedStartDate: startDate, appliedEndDate: endDate, pgno: 1 }, () => {
      const params = {
        pgno: 1,
        status: this.state.status,
        row: this.state.row,
        company_name: this.state.company_name,
        search: this.state.searchText,
        startDate: this.state.appliedStartDate.format('YYYY-MM-DD'),
        endDate: this.state.appliedEndDate.format('YYYY-MM-DD'),
      };
      this.props.VisitorData(params, 'action');
    });
  };

  toggleSearchHandler = () => {
    const isVisible = this.state.isSearchVisible;
    this.setState({
      isSearchVisible: !isVisible,
    });
  };

  toggleCollapsed = () => {
    this.setState(prevState => ({ collapsed: !prevState.collapsed }));
  };

  handleLanguage = langValue => {
    this.setState({
      filterData: langValue,
    });
  };

  openVisitorExportModal = () => {
    this.setState({ showVisitorExportModal: true });
  };




openVisitorPopup = (visitor) => {
  this.setState({
    selectedVisitor: visitor,
    showVisitorPopup: true,
  });
};

closeVisitorPopup = () => {
  this.setState({
    selectedVisitor: null,
    showVisitorPopup: false,
  });
};



handleTableChange = (pagination, filters, sorter) => {
  let order = "";

  if (sorter?.field && sorter?.order) {
    order =
      sorter.order === "ascend"
        ? sorter.field
        : `-${sorter.field}`;
  }

  const params = {
    pgno: pagination.current,
    row: pagination.pageSize,
    order: order,
    status: this.state.status,
    company_name: this.state.company_name,
    search: this.state.searchText,
    startDate: this.state.appliedStartDate.format('YYYY-MM-DD'),
    endDate: this.state.appliedEndDate.format('YYYY-MM-DD'),
  };

  this.setState({
    pgno: pagination.current,
    row: pagination.pageSize,
    SortData: order,
  });


  this.props.VisitorData(params);
};

  closeVisitorExportModal = () => {
    this.setState({ showVisitorExportModal: false });
  };

  shortSelectData = shortallkey => {
    this.setState({
      SortData: shortallkey,
    });
  };

  setPage = e => {
    this.setState({
      pgno: 1,
    });
  };

  chnageSelectMembers = status => {
    this.setState(
      {
        status,
        pgno: 1, // reset page when filter changes
      },
      () => {
        const param = {
          pgno: this.state.pgno,
          row: this.state.row,
          status: this.state.status,
          company_name: this.state.company_name,
          startDate: this.state.appliedStartDate.format('YYYY-MM-DD'),
          endDate: this.state.appliedEndDate.format('YYYY-MM-DD'),
        };


        this.props.VisitorData(param);
      },
    );
  };

  forwordPage(e) {
    this.setState({
      pgno: this.state.pgno + 1,
    });
    let parms = {
      order: this.state.SortData,
      ...this.state.filterData,
      pgno: this.state.pgno + 1,
      status: 'all',
      row: this.state.row,
      company_name: this.state.company_name,
      search: this.state.searchText,
      startDate: this.state.appliedStartDate.format('YYYY-MM-DD'),
      endDate: this.state.appliedEndDate.format('YYYY-MM-DD'),
    };

    this.props.VisitorData(parms);
  }

  pageBackword() {
    this.setState({
      pgno: this.state.pgno - 1,
    });
    let parms = {
      order: this.state.SortData,
      ...this.state.filterData,
      pgno: this.state.pgno - 1,
      status: 'all',
      row: 25,
      company_name: this.state.company_name,
      search: this.state.searchText,
      startDate: this.state.appliedStartDate.format('YYYY-MM-DD'),
      endDate: this.state.appliedEndDate.format('YYYY-MM-DD'),
    };

    this.props.VisitorData(parms);
  }


  

changeFilterData = event => {
  this.setState({ searchText: event.target.value, pgno: 1 }, () => {
      let params = {
        pgno: 1,
        status: 'all',
        row: 25,
        company_name: this.state.company_name,
        search: this.state.searchText,
        startDate: this.state.appliedStartDate.format('YYYY-MM-DD'),
        endDate: this.state.appliedEndDate.format('YYYY-MM-DD'),
      };


      this.props.VisitorData(params, 'default');
    });
  };

  clearSearchBox = () => {
    this.setState({ searchText: '' });
  };




  

  setuserlist = () => {
    const params = {
      pgno: 1,
      status: 'all',
      row: 25,
      company_name: this.state.company_name,
      startDate: this.state.appliedStartDate.format('YYYY-MM-DD'),
      endDate: this.state.appliedEndDate.format('YYYY-MM-DD'),
    };
    this.props.VisitorData(params, 'default');
  };

  selectRows = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    const params = {
      ...this.state.filterData,
      pgno: this.state.pgno,
      row: e.target.value,
      status: 'all',
      company_name: this.state.company_name,
      startDate: this.state.appliedStartDate.format('YYYY-MM-DD'),
      endDate: this.state.appliedEndDate.format('YYYY-MM-DD'),
    };
    this.props.VisitorData(params, 'default');
  };
componentDidMount() {
  this.setuserlist();
  this.fetchServiceAccess();   // ✅ MOVE HERE
}



  fetchServiceAccess = async () => {
    const getCompanyId = this.state.company_id;
    const response = await getServiceAccess(getCompanyId);
    this.setState({ accessServiceLists: response, loaderServiceAccess: false });
  };

  render() {
    const VisitorLogs = this.state.userRole.find(
      element =>
        element.service_id == '3' &&
        (element.role_for_read === '1' || element.role_for_write === '1'),
    );
    if (!VisitorLogs) {
      return <Navigate to="/Dashboard" />;
    }

    const visitorDataTable = this.props.visitorReducer.VisitorTableData;
    const SetTotal = this.props.visitorReducer.VisitorTableData?.total;
    // const listLength = this.props.visitorReducer.VisitorTableData.data !== undefined ?
    // this.props.visitorReducer.VisitorTableData.data.length : 0;
    const Loader = this.props.visitorReducer.loader;

    const headers = [
      { label: 'Name', key: 'name' },
      { label: 'Visitor Type', key: 'type' },
      { label: 'Phone Number', key: 'phone' },
      { label: 'Location', key: 'location' },
      { label: 'Host Name', key: 'hostName' },
      { label: 'Host Email ID', key: 'hostEmail' },
      { label: 'In Time And Date', key: 'inTime' },
      { label: 'Current Status', key: 'status' },

      // { label: 'Email', key: 'email' },

      // { label: 'Company', key: 'company' },
      // { label: 'Out Time And Date', key: 'outTime' },
      // { label: 'Purpose Of Visit', key: 'purpose' },
    ];
    let alldata =
      visitorDataTable && visitorDataTable.data !== undefined
        ? visitorDataTable.data
        : [];

    function getVisitorType(type) {
      if (type == 0) {
        return 'Walkin';
      } else if (type == 1) {
        return 'Invited';
      }
    }

    // var arr2 = alldata.map(v => ({
    //   name: v.fname + v.lname,
    //   email: v.email,
    //   phone: v.phone,
    //   hostName: v.hfirstname + ' ' + v.hlastname,
    //   hostEmail: v.hemail,
    //   location: v.name,
    //   company: v.company,
    //   inTime: v.in_time,
    //   outTime: v.out_time,
    //   purpose: v.purpose,
    //   type: getVisitorType(v.approve_by_client),
    //   status: v.out_time == null ? 'In' : 'Out',
    // }));

    // const csvReport = {
    //   data: arr2,
    //   headers: headers,
    //   filename: 'Visitor_List_Report.csv',
    // };

    const globleToken = getToken();
    if (globleToken === '' || globleToken == null || globleToken == undefined) {
      this.props.history.push('/');
    }

    let serviceAccess = true;
    const serviceAccessId = 3;
    if (this.state.accessServiceLists.length > 0) {
      let serviceAccessobject = {};
      this.state.accessServiceLists.map(e => {
        if (e.id == serviceAccessId) serviceAccessobject = e;
      });
      serviceAccess = false;
      if (serviceAccessobject)
        serviceAccess = serviceAccessobject.service_access;
    }




    return (
      <>
        <Layout>
          <Sidebar collapsed={this.state.collapsed} />

          <CustomHeader
            collapsed={this.state.collapsed}
            toggleCollapsed={this.toggleCollapsed}
          />

          <Layout
            className={
              this.state.collapsed
                ? 'PageLayout CollapsedPageLayout'
                : 'PageLayout'
            }
          >
         {serviceAccess === true ? (
  <>
    <div className="PageContent">
      <div className="row mb-4">
        <div className="col-md-12 col-lg-4">
          <div className="SwHeading">
            <h2>Visitor Management</h2>
          </div>

          <SwToggleButtonGroup
              type="radio"
              name="VisitorOptions"
              value={this.state.status}
              onChange={this.chnageSelectMembers}
              size="sm"
              block
              className="VisitorToggleArea"
              options={[
                { label: 'All', value: 'all' },
                { label: 'In', value: 'active' },
                { label: 'Out', value: 'inactive' },
              ]}
          />
        </div>

        <div className="col-md-12 col-lg-8">
          <div className="PageHead_Optons_Row">
            <ul className='PageHead_Optons_RightAligned'>
              <li>
                <div className="SwInputWithIcon">
                  <SwInput
                    placeholder="Search..."
                    value={this.state.searchText}
                    onChange={this.changeFilterData}
                  />
                  <span className="SwInputicon">
                    <i className="bi bi-search" />
                  </span>
                </div>
              </li>

            </ul>
          </div>
        </div>
      </div>

      <div className="row align-items-center mb-2">
        <div className="col-md-3">
          <div className="SwFormGroup">
            <label className="SwFormLabel">Start Date</label>
            <AntDDatePicker
              format="YYYY-MM-DD"
              placeholder="Select start date"
              value={this.state.startDate}
              disabledDate={this.disabledStartDate}
              onChange={date => {
                this.setState(prev => {
                  const next = { startDate: date };
                  // Only auto-bump End Date if it's now before Start Date
                  if (date && prev.endDate && prev.endDate.isBefore(date, 'day')) {
                    next.endDate = date;
                  }
                  return next;
                });
              }}
              allowClear={false}
            />
          </div>
        </div>
        <div className="col-md-3">
          <div className="SwFormGroup">
            <label className="SwFormLabel">End Date</label>
            <AntDDatePicker
              format="YYYY-MM-DD"
              placeholder="Select end date"
              value={this.state.endDate}
              disabledDate={this.disabledEndDate}
              onChange={date => this.setState({ endDate: date })}
              allowClear={false}
            />
          </div>
        </div>
        <div className="col-md-auto">
          <div className="SwFormGroup">
            <label className="SwFormLabel invisible">No Label</label>
            <SwButton
              type="button"
              variant="primary"
              size="sm"
              onClick={this.handleApply}
              disabled={!this.state.startDate || !this.state.endDate}
            >
              Apply
            </SwButton>
          </div>
        </div>

        <div className="col-md-auto ms-auto">
          <div className="SwFormGroup">
            <label className="SwFormLabel invisible">No Label</label>
            <SwButton
              type="button"
              variant="dark"
              size="sm"
              onClick={this.openVisitorExportModal}
              icon={<i className="bi bi-box-arrow-up-right" />}
              iconPosition="start"
            >
              Export Visitor Logs
            </SwButton>
          </div>
        </div>
      </div>

      {this.state.showSlowLoadMessage && (
        <div className="row mb-2">
          <div className="col-12">
            <div className="SwAlert SwAlert-info">
              Loading is taking longer than expected. Kindly export the data.
            </div>
          </div>
        </div>
      )}

      <div className="row">
        <div className="col-12">
          <div className="">
              <VisitorAntDTable
                currentPage={Number(this.state.pgno)}
                pageSize={Number(this.state.row)}
                onTableChange={this.handleTableChange}
                openVisitorPopup={this.openVisitorPopup} // ✅ pass function
              />
          </div>
        </div>
      </div>
    </div>
  </>
)  : (
  <MarketingPanel />
)}
          </Layout>
        </Layout>

        {this.state.showVisitorExportModal && (
          <VisitorExport onClose={this.closeVisitorExportModal} />
        )}



          {this.state.showVisitorPopup && (
      <SwOffCanvas
        show={this.state.showVisitorPopup}
        onClose={this.closeVisitorPopup}
        title="Visitor Details"
        placement="end"
        backdrop="static"

    footer={
          <div className="OffCanvasFooter_Btns">
          

            <SwButton
              variant="dark-outline"
              
             onClick={this.closeVisitorPopup}
     
            >
                 Close
            </SwButton>
          </div>
        }



        keyboard={false}
      >
        <VisitorPopUp visitor={this.state.selectedVisitor} />
      </SwOffCanvas>
    )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  visitorReducer: state.visitorReducer,
});

const mapActionsToProps = {
  VisitorData,

};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(VisitorManagement);
